var React = require('react');
var ReactDom = require('react-dom');
var UserAlreadyMember = require('../../Views/Feature/MemberJoin/MembershipApplication/ReactDependencies/UserAlreadyMember.jsx');
var MembershipApplication = require('../../Views/Feature/MemberJoin/MembershipApplication/membershipApplication.jsx');
var defaultFetchOptions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx').defaultFetchOptions;

var bootstrap = function () {
    $('.membership-application-wrapper').each(function (index, div) {
        var fullUrl = "/api/reactforms/GetMemberJoinApplicationInfo";
        var membershipSummaryUrl = "/api/account/getmembershipsummary";

        fetch(fullUrl, defaultFetchOptions())
            .then((res) => {
                return res.json();
            })
            .then((result) => {

                // If the user has a proforma, let them know they need to renew
                fetch(membershipSummaryUrl, defaultFetchOptions())
                    .then((res) => {
                        return res.json();
                    })
                    .then((membershipSummaryResponse) => {
                        // The "Renew" link means this user has a proforma
                        if (membershipSummaryResponse && membershipSummaryResponse.response.LinkToDisplay == "Renew") {
                            ReactDom.render(<UserAlreadyMember fullName={result.fullName} proforma={true} />, div);
                            return;
                        }

                        // If the user is has an active membership, display this message
                        if (result && result._isMember) {
                            var membershipType =
                                result.userInfo &&
                                    result.userInfo.CustomerInformation &&
                                    result.userInfo.CustomerInformation.length
                                    ? result.userInfo.CustomerInformation[0].MembershipType
                                    : '';

                            ReactDom.render(<UserAlreadyMember fullName={result.fullName} membershipType={membershipType} />, div);
                            return;
                        }
                    });

                var step = result && result.applicationType ? 3 : 0;
                step = result.orderNumber ? 6 : step;

                ReactDom.render(
                    <MembershipApplication
                        currentStep={step}
                        applicationType={result.applicationType}
                        productType={result.productType}
                        rateType={result.rateType}
                        isMilitary={result.isMilitary}
                        isGovernmentEmployee={result.isGovernmentEmployee}
                        accountFullName={result.userInfo.FullName}
                        primaryPracticeLocation={result.primaryPracticeLocation}
                        primaryDistrictLocation={result.primaryDistrictLocation}
                        yearsInPractice={result.yearsInPractice}
                        orderNumber={result.orderNumber}
                    />,
                    div
                );

            }, (error) => {
                ReactDom.render(
                    <MembershipApplication currentStep={0} />,
                    div
                );
            });
    });
}

$(function () {
    bootstrap();
    $('html, body').animate({ scrollTop: 0 }, '50');
});